import MkuCheckboxGroup from './src/checkbox-group';

MkuCheckboxGroup.install = function (Vue) {
  Vue.component(MkuCheckboxGroup.name, MkuCheckboxGroup);
};

export default MkuCheckboxGroup;
